import { render } from "./ManageLayout.vue?vue&type=template&id=18423a16&scoped=true"
import script from "./ManageLayout.vue?vue&type=script&lang=js"
export * from "./ManageLayout.vue?vue&type=script&lang=js"

import "./ManageLayout.vue?vue&type=style&index=0&id=18423a16&lang=css"
import "./ManageLayout.vue?vue&type=style&index=1&id=18423a16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18423a16"]])

export default __exports__